import type { NavGroup } from './org-page-redesign/types';

export const DOSESPOT_BADGES: Record<string, { label: string; tone: 'success' | 'warn' }> = {
  completed: { label: 'Connected', tone: 'success' },
  idp_needed: { label: 'IDP needed', tone: 'warn' },
  tfa_needed: { label: '2FA needed', tone: 'warn' },
};

/**
 * Nav groups for the provider workspace rail. Shared between the provider
 * detail page (sections rendered in-page) and provider subpage layouts
 * (which navigate back to the detail page's section). Live counts/statuses
 * ride along as badges so the sidebar doubles as a status readout; callers
 * without those datapoints omit them and the badges simply don't render.
 */
export function buildProviderNavGroups(
  hasOrganization: boolean,
  noteCount: number | undefined,
  dosespotStatus: string | null | undefined,
): NavGroup[] {
  return [
    {
      label: 'Member',
      items: [{ key: 'overview', label: 'Overview' }],
    },
    {
      label: 'Configuration',
      items: [
        ...(hasOrganization ? [{ key: 'bundles', label: 'Bundles' }] : []),
        { key: 'feature-flags', label: 'Feature Flags' },
        { key: 'feature-gates', label: 'Feature Gates' },
        { key: 'voice-enrollment', label: 'Voice Enrollment' },
        { key: 'google-calendar', label: 'Google Calendar' },
        {
          key: 'dosespot',
          label: 'JotRX',
          badge: dosespotStatus
            ? (DOSESPOT_BADGES[dosespotStatus] ?? { label: dosespotStatus, tone: 'warn' })
            : undefined,
        },
      ],
    },
    {
      label: 'Resources',
      items: [
        {
          key: 'notes',
          label: 'Notes',
          badge:
            noteCount != null ? { label: noteCount.toLocaleString(), tone: 'default' } : undefined,
        },
        { key: 'transcriptions', label: 'Transcriptions' },
        { key: 'encounters', label: 'Encounters' },
        { key: 'appointments', label: 'Appointments' },
        { key: 'note-processing-sessions', label: 'Note Processing Sessions' },
        { key: 'templates', label: 'Templates' },
        { key: 'encounter-types', label: 'Encounter Types' },
        { key: 'resources', label: 'Resource Explorer' },
      ],
    },
    {
      label: 'Tools',
      items: [
        { key: 'streaming-threads', label: 'Streaming Threads' },
        ...(hasOrganization
          ? [{ key: 'shadow-notes', label: 'Shadow Notes', external: true }]
          : []),
        { key: 'patient-containers', label: 'Patient Containers', external: true },
        { key: 'session-replays', label: 'Session Replays', external: true },
      ],
    },
  ];
}
